export default __webpack_public_path__ + "static/flag-fr-78919920f4cb7b226a87434314744907.svg";